import Vue from 'vue';
import Vuex from 'vuex';

import experian from './modules/experian.module';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        experian
    },
});
